import { customerApi } from '../index';
import { apiRoutes } from '../apiRoutes';
import { CompanyData } from './types';

export const getCompanyData = async (displayId: string) => {
  const response = await customerApi.get<CompanyData>(apiRoutes.company.byId(displayId));

  return response?.data;
};
